// Navbar.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  FaMoon,
  FaSun,
  FaBars,
  FaTimes
} from 'react-icons/fa';

import logo from './assets/logo.png';

function Navbar({ theme, toggleTheme }) {

  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="navbar">

      <div className="container navbar-content">

        {/* LOGO */}
        <Link to="/" className="logo">
          <img
            src={logo}
            alt="Company Logo"
            className="logo-image"
          />
        </Link>

        {/* DESKTOP MENU */}
        <nav className="nav-links">

          <a href="/#home">Home</a>

          <a href="/#about">About</a>

          <a href="/#services">Services</a>

          <a href="/#team">Team</a>

          <a href="/#portfolio">Portfolio</a>

          <a href="/#contact">Contact</a>

        </nav>

        {/* RIGHT SIDE */}
        <div className="nav-right">

          {/* THEME BUTTON */}
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            type="button"
            aria-label="Toggle theme"
          >
            {theme === 'light'
              ? <FaMoon />
              : <FaSun />
            }
          </button>

          {/* MOBILE MENU BUTTON */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>

        </div>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>

        <a href="/#home" onClick={closeMenu}>
          Home
        </a>

        <a href="/#about" onClick={closeMenu}>
          About
        </a>

        <a href="/#services" onClick={closeMenu}>
          Services
        </a>

        <a href="/#team" onClick={closeMenu}>
          Team
        </a>

        <a href="/#portfolio" onClick={closeMenu}>
          Portfolio
        </a>

        <a href="/#contact" onClick={closeMenu}>
          Contact
        </a>

      </div>

    </header>
  );
}

export default Navbar;